export default "__VITE_ASSET__DPh0_pLU__"